// PHASE 7: Statistics on home-emotion connection
import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function SpaceEmotionFeedbackPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <FeedbackPage
      emoji="💓"
      heading={t('pages.onboarding.v2.spaceEmotionFeedback.heading')}
      text={t('pages.onboarding.v2.spaceEmotionFeedback.description')}
      onSubmit={handleSubmit}
    />
  )
}
